<script>
import CommonTableComponent from "@/components/table.vue";

import appConfig from "@/app.config.json";
import tableSearch from "@/mixins/tableSearch";
import pagination from "@/mixins/pagination";
import router from "@/mixins/router";
import Layout from "@/views/layouts/main.vue";
import apiEndpoints from "@/services/apiEndpoints";
import SearchDataVendorModal from "@/components/InputSearchModal/SearchDataVendorModal.vue";
import SearchDataCustomerModal from "@/components/InputSearchModal/SearchDataCustomerModal.vue";
import SearchDataDischargerModal from "@/components/InputSearchModal/SearchDataDischargerModal.vue";
import SearchDataDischargerSiteModal from "@/components/InputSearchModal/SearchDataDischargerSiteModal.vue";
import user from "@/mixins/user";

export default {
  name: "Projects",
  page: {
    title: "商流一覧",
    meta: [{ name: "description", content: appConfig.description }]
  },
  mixins: [tableSearch, pagination, router, user],
  components: {
    Layout,
    CommonTableComponent,
    SearchDataVendorModal,
    SearchDataCustomerModal,
    SearchDataDischargerModal,
    SearchDataDischargerSiteModal
  },
  data() {
    return {
      projects: [],
      filters: {
        case_name: this.$route.query.case_name || "",
        customer: this.$route.query.customer || "",
        discharger: this.$route.query.discharger || "",
        discharger_site: this.$route.query.discharger_site || "",
        vendor: this.$route.query.vendor || "",
        column: this.$route.query.column || "cases.case_cd",
        dir: this.$route.query.dir || "DESC",
        page: this.$route.query.page || 1,
        keywords: this.$route.query.keywords || '',
        searchToken: 0
      },
      total_records: 0,
      isLoading: false,
      searchError:null,
    };
  },
  created() {
    this.getData();
  },
  methods: {
    async getData() {
      this.isLoading = true;
      const sendApiProject = await this.$http.get(
        apiEndpoints.projects,
        this.filters
      );
      const { status, data } = sendApiProject;

      if (status && data.result) {
        this.total_records = data.result.total;
        this.projects = data.result.data;
        const meta = this.$_.isEmpty(data.result.meta) ? [] : data.result.meta;
        this.setMeta(meta);
      }
      this.searchError = data.errors;
      this.isLoading = false;
    },
    search() {
      this.resetToFirstPage();
      this.updateUrlFilters();
    },
    onSelectData(data) {
      this.filters = data;
    },
    clearDataSearch() {
      for (const key in this.filters) {
          this.filters[key] = ""
      }
      this.filters.column = "cases.case_cd";
      this.filters.dir = "DESC";
      this.resetToFirstPage();
      this.updateUrlFilters();
    }
  },
  computed: {
    headers() {
      return [
        {
          text: "AK管理番号",
          value: "cases.case_cd",
          sortable: true
        },
        {
          text: "商流",
          value: "case_name",
          sortable: true
        },
        {
          text: "得意先略称",
          value: "customer_id",
          sortable: true
        },
        {
          text: "事業者略称",
          value: "discharger_id",
          sortable: true
        },
        {
          text: "事業場略称",
          value: "discharger_site_id",
          sortable: true
        },
        {
          text: "関係委託先",
          value: "vendor_id",
          sortable: true
        },
        {
          text: "",
          value: "work_reservation",
          sortable: false
        }
      ];
    },
    queryPage() {
      return this.$route.query;
    },
    totalRows() {
      return this.total_records;
    }
  },
  watch: {
    "filters.page": {
      immediate: false,
      handler(newVal, oldVal) {
        this.updateFiltersWithoutSearch();
        this.updateUrlFilters();
      }
    },
  }
};
</script>
<template>
  <Layout>
    <b-card class="mb-1">
      <b-row>
        <b-col md="6">
          <SearchDataCustomerModal
            :dataSearch="filters"
            :errorValid="this.searchError"
            @dataSelected="onSelectData"
          />
        </b-col>
        <b-col md="6">
          <SearchDataDischargerModal
            :dataSearch="filters"
            :errorValid="this.searchError"
            @dataSelected="onSelectData"
          />
        </b-col>
      </b-row>
      <b-row>
        <b-col md="6">
          <SearchDataDischargerSiteModal
            :dataSearch="filters"
            :errorValid="this.searchError"
            @dataSelected="onSelectData"
          />
        </b-col>
        <b-col md="6">
          <SearchDataVendorModal
            :dataSearch="filters"
            :errorValid="this.searchError"
            @dataSelected="onSelectData"
          />
        </b-col>
      </b-row>
      <b-row>
        <div class="d-flex justify-content-center align-items-center">
          <b-button size="lg" variant="primary" @click="search" class="me-2">
            <div class="d-flex align-items-center justify-content-center">
              <i class="fas fa-search"></i> {{ this.$lang.button.search }}
            </div>
          </b-button>
          <b-button @click="clearDataSearch" variant="dark" size="lg">
            <i class="fas fa-eraser"></i> {{ this.$lang.button.clear }}
          </b-button>
        </div>
      </b-row>
      <b-row>
        <div class="mt-2">
          <input
            placeholder="フィルター..."
            v-model="filters.keywords"
            v-on:keyup.enter="search()"
            type="text"
            class="form-control me-2"
          />
        </div>
      </b-row>
    </b-card>
    <b-card class="p-0">
      <CommonTableComponent :height-class="`table-wrapper-500`">
        <thead class="table-light">
        <tr>
          <th
            v-for="(item, index) in headers"
            :key="index"
            :class="getHeaderClass(item)"
          >
                <span v-if="item.sortable" @click="clickSort(item.value)">
                  {{ item.text }}
                  <i :class="getSortClass(item.value)"></i>
                </span>
            <span v-else>
                  {{ item.text }}
                </span>
          </th>
        </tr>
        </thead>
        <tbody>
        <tr
          class="cursor-pointer"
          v-for="(item, index) in projects"
          :key="index"
          @click.exact="
                redirectRoute(
                  'projects.sales',
                  { id: item.id },
                  {},
                  queryPage,
                  'projects'
                )
              "
          @click.ctrl="
                redirectRouteTargetBlank(
                  'projects.sales',
                  {
                    id: item.id
                  },
                  {},
                  queryPage,
                  'projects'
                )
              "
        >
          <td @click.stop>{{ item.case_cd }}</td>
          <td>{{ item.case_name }}</td>
          <td>{{ item.customer && item.customer.name_abbreviated }}</td>
          <td>{{ item.discharger && item.discharger.name_abbreviated }}</td>
          <td>
            {{
              item.discharger_site && item.discharger_site.name_abbreviated
            }}
          </td>
          <td>{{ item.vendor && item.vendor.name_abbreviated }}</td>
          <td class="text-center" @click.stop>
            <router-link :to="!canUserEdit() ? '' : {name: 'projects.work_reservations.register', params: {case_id: item.id}}">
              <button
                class="btn btn-primary w-md waves-effect waves-light"
                :disabled="!canUserEdit()"
              >
                作業予約
              </button>
            </router-link>
          </td>
        </tr>
        <tr v-if="!projects.length && !isLoading">
          <td colspan="6" class="text-center">
            データなし。
          </td>
        </tr>
        </tbody>
      </CommonTableComponent>
      <div
        class="d-flex justify-content-between mt-3"
        v-if="meta.total && Object.keys(meta).length"
      >
        <div class="d-flex align-items-center">
          <b-pagination
            v-model="filters.page"
            :total-rows="meta.total"
            :per-page="meta.per_page"
          ></b-pagination>
        </div>
        <div class="d-flex align-items-center">
          <div class="me-2">
            {{ meta.from }} - {{ meta.to }} / {{ meta.total }}
          </div>
        </div>
      </div>
    </b-card>
  </Layout>
</template>
